/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types';
/** RTK Query */
import {
    useAddProjectComponentMutation,
    useUpdateProjectComponentMutation
} from '../../../../../../app/services/projectComponentAPI';
/** Common Services & Data Files */
import ToastService from '../../../../../../services/toastService/ToastService';
import Buttons from '../../../../../../components/ui/button/Buttons';
import FormCreator from '../../../../../../components/finalForms/FormCreator';
import ProjectComponentForm from './config/AddProjectComponent.Data';

const AddProjectComponent = (props) => {
    const resetpcdref = useRef();
    /* State*/
    const [form, setForm] = useState(ProjectComponentForm);
    const ProjectId = props.projectId;
    // API'S Call
    const [addProjectComponent, {
        isSuccess: isProjectComponentAdded,
        isLoading: isProjectComponentAdding,
        data: addProjectComponentData
    },] = useAddProjectComponentMutation();
    
    const [updateProjectComponent, {
        isLoading: updateProjectComponentLoading,
        isSuccess: isSuccessUpdateProjectComponent,
        data: updateProjectComponentData,
    },] = useUpdateProjectComponentMutation();

    //** useEffect's */
    useEffect(() => {
        if (props.isEdit && props.componentData) {
            const formData = { ...ProjectComponentForm }
            formData.initialState = {
                projectComponent: props.componentData.projectComponent
            }
            setForm(formData);
        } else {
            resetForm();
        }
    }, [props.isEdit && props.componentData]);

    useEffect(() => {
        if (isProjectComponentAdded && addProjectComponentData) {
            if (addProjectComponentData.errorMessage.includes("exists")) {
                ToastService.warning(addProjectComponentData.errorMessage);
                return;
            }
            else {
                ToastService.success(addProjectComponentData.errorMessage);
                backToList();
            }
        }
    }, [isProjectComponentAdded, addProjectComponentData]);

    useEffect(() => {
        if (isSuccessUpdateProjectComponent && updateProjectComponentData) {
            if (updateProjectComponentData.errorMessage.includes("exists")) {
                ToastService.warning(updateProjectComponentData.errorMessage);
                return;
            } else {
                ToastService.success(updateProjectComponentData.errorMessage);
                backToList();
            }
        }
    }, [isSuccessUpdateProjectComponent, updateProjectComponentData]);

    //** Funcation's */
    const resetForm = () => {
        const formData = { ...ProjectComponentForm }
        form.initialState = { ...ProjectComponentForm.initialState }
        setForm(formData);
    }

    const handleSaveClick = () => {
        const ProjectComponentForm = resetpcdref.current.getFormData();
        if (ProjectComponentForm) {
            const requestData = {
                ...ProjectComponentForm,
                projectComponent: ProjectComponentForm.projectComponent,
                projectId: ProjectId,
                projectComponentId: props.isEdit ? props.componentData.projectComponentId : null,
            }
            if (props.isEdit) {
                updateProjectComponent(requestData)
            } else {
                addProjectComponent(requestData);
            }

        }
    }

    const backToList = () => {
        props?.onClose();
        resetForm();
    };

    return (
        <div className="">
            <form>
                <div className="row">
                    <FormCreator
                        config={form}
                        ref={resetpcdref}
                    />
                </div>
            </form>
            <div className="d-flex justify-content-end">
                <Buttons
                    buttonTypeClassName="dark-btn"
                    buttonText="Cancel"
                    onClick={backToList}
                />
                <Buttons
                    buttonTypeClassName="theme-btn ml-4"
                    buttonText={props.isEdit ? "Update" : "Add"}
                    onClick={handleSaveClick}
                    isLoading={isProjectComponentAdding || updateProjectComponentLoading}
                />
            </div>
        </div>
    )
}

AddProjectComponent.propTypes = {
    onClose: PropTypes.func.isRequired,
};

export default AddProjectComponent
